export class MakeModel {

    static concatFromYearToYearMakeModel(fromYear: number | null, toYear: number | null, make: string, model: string): string {
        // Defaults
        make = typeof make === 'string' && make ? make.toUpperCase() : '';
        model = typeof model === 'string' && model ? model.toUpperCase() : '';

        let r = '';

        // From year
        r += fromYear
            ? fromYear
            : '';

        // To year
        r += toYear
            ? r.length > 0
                ? ' - ' + toYear
                : toYear
            : '';

        // Make
        r += ' ' + make;

        // Model
        r += ' ' + model;

        return r.trim();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/helpers/makeModel.ts